//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Geeft alle beschikbare geldverstrekkers.
     * @return Success
     */
    geldverstrekkers_ophalen(): Promise<GeldverstrekkersOutput> {
        let url_ = this.baseUrl + "/Geldverstrekkers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeldverstrekkers_ophalen(_response);
        });
    }

    protected processGeldverstrekkers_ophalen(response: Response): Promise<GeldverstrekkersOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeldverstrekkersOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeldverstrekkersOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GeldverstrekkersOutput>(null as any);
    }

    /**
     * Geeft de rentevastperiodes op basis van aflossingsvorm, renteafspraak en onderpand voor de opgegeven geldverstrekkers.
     * @param geldverstrekkerCodes De codes van de geldverstrekkers waarvoor de informatie gezocht wordt. Codes gescheiden door een komma.
     * @param aflossingsvorm De aflossingsvorm die gevraagd wordt 0 = Geen, 1 = Annuïteit, 2 = Lineair, 3 = Levensverzekering, 4 = Spaar, 5 = Aflosvrij, 9 = Krediet, 10 = Belegging, 11 = Hybride, 12 = UnitLinked, 13 = Spaarrekening, 20 = AnnuïteitUitgesteld
     * @param renteafspraak De renteafspraak die gevraagd wordt 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie
     * @param soortOnderpand Het soort onderpand dat gevraagd wordt 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw
     * @return Success
     */
    rentevastperiodes_ophalen(geldverstrekkerCodes: string, aflossingsvorm: Aflossingsvorm, renteafspraak: Renteafspraak, soortOnderpand: SoortOnderpand): Promise<RentevastperiodesOutput> {
        let url_ = this.baseUrl + "/Geldverstrekkers/{geldverstrekkerCodes}/Aflossingsvorm/{aflossingsvorm}/Renteafspraak/{renteafspraak}/SoortOnderpand/{soortOnderpand}/Rentevastperiodes";
        if (geldverstrekkerCodes === undefined || geldverstrekkerCodes === null)
            throw new Error("The parameter 'geldverstrekkerCodes' must be defined.");
        url_ = url_.replace("{geldverstrekkerCodes}", encodeURIComponent("" + geldverstrekkerCodes));
        if (aflossingsvorm === undefined || aflossingsvorm === null)
            throw new Error("The parameter 'aflossingsvorm' must be defined.");
        url_ = url_.replace("{aflossingsvorm}", encodeURIComponent("" + aflossingsvorm));
        if (renteafspraak === undefined || renteafspraak === null)
            throw new Error("The parameter 'renteafspraak' must be defined.");
        url_ = url_.replace("{renteafspraak}", encodeURIComponent("" + renteafspraak));
        if (soortOnderpand === undefined || soortOnderpand === null)
            throw new Error("The parameter 'soortOnderpand' must be defined.");
        url_ = url_.replace("{soortOnderpand}", encodeURIComponent("" + soortOnderpand));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRentevastperiodes_ophalen(_response);
        });
    }

    protected processRentevastperiodes_ophalen(response: Response): Promise<RentevastperiodesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentevastperiodesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentevastperiodesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentevastperiodesOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentevastperiodesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentevastperiodesOutput>(null as any);
    }

    /**
     * Geeft de lijst met geldverstrekkers die een toetsrente hebben met de gegeven filters.
     * @param geldverstrekkerCodes De codes van de geldverstrekker(s). Codes gescheiden door een komma.
     * @param hypotheeklabelCode Het hypotheeklabel binnen de geldverstrekker(s)
     * @param rentevastAantalMaanden De rentevastperiode in aantal maanden
     * @return Success
     */
    toetsrenteInfo_ophalen(geldverstrekkerCodes: string, hypotheeklabelCode: number, rentevastAantalMaanden: number): Promise<HasToetsrenteOutput> {
        let url_ = this.baseUrl + "/Geldverstrekkers/{geldverstrekkerCodes}/HasToetsrente/Hypotheeklabels/{hypotheeklabelCode}/Rentevastperiode/{rentevastAantalMaanden}";
        if (geldverstrekkerCodes === undefined || geldverstrekkerCodes === null)
            throw new Error("The parameter 'geldverstrekkerCodes' must be defined.");
        url_ = url_.replace("{geldverstrekkerCodes}", encodeURIComponent("" + geldverstrekkerCodes));
        if (hypotheeklabelCode === undefined || hypotheeklabelCode === null)
            throw new Error("The parameter 'hypotheeklabelCode' must be defined.");
        url_ = url_.replace("{hypotheeklabelCode}", encodeURIComponent("" + hypotheeklabelCode));
        if (rentevastAantalMaanden === undefined || rentevastAantalMaanden === null)
            throw new Error("The parameter 'rentevastAantalMaanden' must be defined.");
        url_ = url_.replace("{rentevastAantalMaanden}", encodeURIComponent("" + rentevastAantalMaanden));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToetsrenteInfo_ophalen(_response);
        });
    }

    protected processToetsrenteInfo_ophalen(response: Response): Promise<HasToetsrenteOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HasToetsrenteOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HasToetsrenteOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HasToetsrenteOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HasToetsrenteOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HasToetsrenteOutput>(null as any);
    }

    /**
     * Geeft alle beschikbare hypotheeklabels van de geldverstrekker.
     * @param geldverstrekkerId Unieke identificatie van de geldverstrekker
     * @return Success
     */
    hypotheeklabels_van_geldverstrekker_ophalen(geldverstrekkerId: string): Promise<HypotheeklabelsOutput> {
        let url_ = this.baseUrl + "/Geldverstrekkers/{geldverstrekkerId}/Hypotheeklabels";
        if (geldverstrekkerId === undefined || geldverstrekkerId === null)
            throw new Error("The parameter 'geldverstrekkerId' must be defined.");
        url_ = url_.replace("{geldverstrekkerId}", encodeURIComponent("" + geldverstrekkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheeklabels_van_geldverstrekker_ophalen(_response);
        });
    }

    protected processHypotheeklabels_van_geldverstrekker_ophalen(response: Response): Promise<HypotheeklabelsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelsOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelsOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelsOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheeklabelsOutput>(null as any);
    }

    /**
     * Geeft alle beschikbare hypotheeklabels, eventueel gefilterd op geldverstrekkercode.
     * @param geldverstrekkerCode (optional) Optioneel: Code van de geldverstrekker
     * @return Success
     */
    hypotheeklabels_ophalen(geldverstrekkerCode: string | null | undefined): Promise<HypotheeklabelsOutput> {
        let url_ = this.baseUrl + "/Hypotheeklabels?";
        if (geldverstrekkerCode !== undefined && geldverstrekkerCode !== null)
            url_ += "geldverstrekkerCode=" + encodeURIComponent("" + geldverstrekkerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheeklabels_ophalen(_response);
        });
    }

    protected processHypotheeklabels_ophalen(response: Response): Promise<HypotheeklabelsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelsOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelsOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelsOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheeklabelsOutput>(null as any);
    }

    /**
     * Geeft alle beschikbare hypotheekvormen van het hypotheeklabel van de geldverstrekker.
     * @param geldverstrekkerCode De code van de geldverstrekker die gevraagd wordt
     * @param hypotheeklabelCode De code van het hypotheeklabel van de geldverstrekker dat gevraagd wordt
     * @return Success
     */
    hypotheekvormen_van_hypotheeklabel(geldverstrekkerCode: string, hypotheeklabelCode: number): Promise<HypotheekvormenOutput> {
        let url_ = this.baseUrl + "/Geldverstrekkers/{geldverstrekkerCode}/Hypotheeklabels/{hypotheeklabelCode}/Hypotheekvormen";
        if (geldverstrekkerCode === undefined || geldverstrekkerCode === null)
            throw new Error("The parameter 'geldverstrekkerCode' must be defined.");
        url_ = url_.replace("{geldverstrekkerCode}", encodeURIComponent("" + geldverstrekkerCode));
        if (hypotheeklabelCode === undefined || hypotheeklabelCode === null)
            throw new Error("The parameter 'hypotheeklabelCode' must be defined.");
        url_ = url_.replace("{hypotheeklabelCode}", encodeURIComponent("" + hypotheeklabelCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheekvormen_van_hypotheeklabel(_response);
        });
    }

    protected processHypotheekvormen_van_hypotheeklabel(response: Response): Promise<HypotheekvormenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekvormenOutput>(null as any);
    }

    /**
     * Geeft het maximale marktwaardepercentage waarmee een rente opgehaald kan worden voor de gegeven parameters.
     * @param geldverstrekkerCode Code van de geldverstrekker
     * @param hypotheeklabelCode Nummer van het hypotheeklabel van de geldverstrekker
     * @param hypotheekvormCode Nummer van de hypotheekvorm binnen het hypotheeklabel (RenteboxCode uit product API)
     * @param renteafspraak (optional) Renteafspraak die gezocht wordt 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie
     * @param soortOnderpand (optional) Soort onderpand dat gebruikt wordt 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw
     * @param nhg (optional) Geeft aan of er sprake is van NHG
     * @return Success
     */
    maximaal_marktwaardepercentage(geldverstrekkerCode: string, hypotheeklabelCode: number, hypotheekvormCode: number, renteafspraak: Renteafspraak2 | null | undefined, soortOnderpand: SoortOnderpand2 | null | undefined, nhg: boolean | null | undefined): Promise<MaxMarktwaardePercentageOutput> {
        let url_ = this.baseUrl + "/Geldverstrekkers/{geldverstrekkerCode}/Hypotheeklabels/{hypotheeklabelCode}/Hypotheekvormen/{hypotheekvormCode}/Marktwaardes/MaxMarktwaardePercentage?";
        if (geldverstrekkerCode === undefined || geldverstrekkerCode === null)
            throw new Error("The parameter 'geldverstrekkerCode' must be defined.");
        url_ = url_.replace("{geldverstrekkerCode}", encodeURIComponent("" + geldverstrekkerCode));
        if (hypotheeklabelCode === undefined || hypotheeklabelCode === null)
            throw new Error("The parameter 'hypotheeklabelCode' must be defined.");
        url_ = url_.replace("{hypotheeklabelCode}", encodeURIComponent("" + hypotheeklabelCode));
        if (hypotheekvormCode === undefined || hypotheekvormCode === null)
            throw new Error("The parameter 'hypotheekvormCode' must be defined.");
        url_ = url_.replace("{hypotheekvormCode}", encodeURIComponent("" + hypotheekvormCode));
        if (renteafspraak !== undefined && renteafspraak !== null)
            url_ += "renteafspraak=" + encodeURIComponent("" + renteafspraak) + "&";
        if (soortOnderpand !== undefined && soortOnderpand !== null)
            url_ += "soortOnderpand=" + encodeURIComponent("" + soortOnderpand) + "&";
        if (nhg !== undefined && nhg !== null)
            url_ += "nhg=" + encodeURIComponent("" + nhg) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaximaal_marktwaardepercentage(_response);
        });
    }

    protected processMaximaal_marktwaardepercentage(response: Response): Promise<MaxMarktwaardePercentageOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaxMarktwaardePercentageOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaxMarktwaardePercentageOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaxMarktwaardePercentageOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaxMarktwaardePercentageOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaxMarktwaardePercentageOutput>(null as any);
    }

    /**
     * Geeft de marktwaardes met bijbehorende rente-opslagen voor de gegeven parameters.
    Hierbij wordt de basisrente bepaald door het gegeven 'marktwaardePercentage'.
     * @param geldverstrekkerCode Code van de geldverstrekker
     * @param hypotheeklabelCode Nummer van het hypotheeklabel van de geldverstrekker
     * @param hypotheekvormCode Nummer van de hypotheekvorm binnen het hypotheeklabel (RenteboxCode uit product API)
     * @param renteafspraak (optional) Renteafspraak die gezocht wordt 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie
     * @param rentevastAantalMaanden (optional) Rentevastperiode die gezocht wordt (in aantal maanden)
     * @param rentebedenktijdInMaanden (optional) Bedenktijd die gezocht wordt (in aantal maanden)
     * @param soortOnderpand (optional) Soort onderpand dat gebruikt wordt 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw
     * @param marktwaardePercentage (optional) Marktwaardepercentage waarmee de basisrente wordt bepaald
     * @param nhg (optional) Geeft aan of er sprake is van NHG
     * @return Success
     */
    opslag_per_marktwaarde_ophalen(geldverstrekkerCode: string, hypotheeklabelCode: number, hypotheekvormCode: number, renteafspraak: Renteafspraak3 | null | undefined, rentevastAantalMaanden: number | null | undefined, rentebedenktijdInMaanden: number | null | undefined, soortOnderpand: SoortOnderpand3 | null | undefined, marktwaardePercentage: number | null | undefined, nhg: boolean | null | undefined): Promise<MarktwaardesOutput> {
        let url_ = this.baseUrl + "/Geldverstrekkers/{geldverstrekkerCode}/Hypotheeklabels/{hypotheeklabelCode}/Hypotheekvormen/{hypotheekvormCode}/Marktwaardes/Opslagen?";
        if (geldverstrekkerCode === undefined || geldverstrekkerCode === null)
            throw new Error("The parameter 'geldverstrekkerCode' must be defined.");
        url_ = url_.replace("{geldverstrekkerCode}", encodeURIComponent("" + geldverstrekkerCode));
        if (hypotheeklabelCode === undefined || hypotheeklabelCode === null)
            throw new Error("The parameter 'hypotheeklabelCode' must be defined.");
        url_ = url_.replace("{hypotheeklabelCode}", encodeURIComponent("" + hypotheeklabelCode));
        if (hypotheekvormCode === undefined || hypotheekvormCode === null)
            throw new Error("The parameter 'hypotheekvormCode' must be defined.");
        url_ = url_.replace("{hypotheekvormCode}", encodeURIComponent("" + hypotheekvormCode));
        if (renteafspraak !== undefined && renteafspraak !== null)
            url_ += "renteafspraak=" + encodeURIComponent("" + renteafspraak) + "&";
        if (rentevastAantalMaanden !== undefined && rentevastAantalMaanden !== null)
            url_ += "rentevastAantalMaanden=" + encodeURIComponent("" + rentevastAantalMaanden) + "&";
        if (rentebedenktijdInMaanden !== undefined && rentebedenktijdInMaanden !== null)
            url_ += "rentebedenktijdInMaanden=" + encodeURIComponent("" + rentebedenktijdInMaanden) + "&";
        if (soortOnderpand !== undefined && soortOnderpand !== null)
            url_ += "soortOnderpand=" + encodeURIComponent("" + soortOnderpand) + "&";
        if (marktwaardePercentage !== undefined && marktwaardePercentage !== null)
            url_ += "marktwaardePercentage=" + encodeURIComponent("" + marktwaardePercentage) + "&";
        if (nhg !== undefined && nhg !== null)
            url_ += "nhg=" + encodeURIComponent("" + nhg) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOpslag_per_marktwaarde_ophalen(_response);
        });
    }

    protected processOpslag_per_marktwaarde_ophalen(response: Response): Promise<MarktwaardesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarktwaardesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarktwaardesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarktwaardesOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarktwaardesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarktwaardesOutput>(null as any);
    }

    /**
     * Geeft de marktwaardes met bijbehorende rente-opslagen van alle actieve hypotheeklabels voor de gevraagde aflossingsvormen.
    Hierbij wordt de basisrente bepaald door het gegeven 'marktwaardePercentage'.
     * @param input (optional) Input voor het bepalen van de marktwaardes met bijbehorende rente-opslagen
     * @return Success
     */
    opslagen_voor_meerdere_aflossingsvormen_ophalen(input: HypotheeklabelMarktwaardeInput | null | undefined): Promise<HypotheeklabelMarktwaardesOutput> {
        let url_ = this.baseUrl + "/Marktwaardes/Opslagen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOpslagen_voor_meerdere_aflossingsvormen_ophalen(_response);
        });
    }

    protected processOpslagen_voor_meerdere_aflossingsvormen_ophalen(response: Response): Promise<HypotheeklabelMarktwaardesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelMarktwaardesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelMarktwaardesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelMarktwaardesOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelMarktwaardesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheeklabelMarktwaardesOutput>(null as any);
    }

    /**
     * Geeft een renteoverzicht op basis van rentevastperiode.
     * @param soortOnderpand (optional) Het soort onderpand waarvoor gezocht wordt 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw
     * @param aflossingsvorm (optional) De aflossingsvorm die gezocht wordt 0 = Geen, 1 = Annuïteit, 2 = Lineair, 3 = Levensverzekering, 4 = Spaar, 5 = Aflosvrij, 9 = Krediet, 10 = Belegging, 11 = Hybride, 12 = UnitLinked, 13 = Spaarrekening, 20 = AnnuïteitUitgesteld
     * @param renteafspraak (optional) De renteafspraak die gezocht wordt 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie
     * @param rentevastAantalMaanden (optional) Aantal maanden rentevastperiode dat gezocht wordt
     * @param rentebedenktijdInMaanden (optional) Het aantal maanden rentebedenktijd dat gezocht wordt
     * @param percentageToShowList (optional) De percentages die opgenomen moeten worden. De waarden worden gescheiden door puntkomma's, bijvoorbeeld 60;72,5;90;100.
     * @return Success
     */
    renteoverzichtObvRentevastperiode(soortOnderpand: SoortOnderpand4 | null | undefined, aflossingsvorm: Aflossingsvorm2 | null | undefined, renteafspraak: Renteafspraak4 | null | undefined, rentevastAantalMaanden: number | null | undefined, rentebedenktijdInMaanden: number | null | undefined, percentageToShowList: string | null | undefined): Promise<RenteoverzichtOutput> {
        let url_ = this.baseUrl + "/Renteoverzicht/ObvRentevastPeriode?";
        if (soortOnderpand !== undefined && soortOnderpand !== null)
            url_ += "SoortOnderpand=" + encodeURIComponent("" + soortOnderpand) + "&";
        if (aflossingsvorm !== undefined && aflossingsvorm !== null)
            url_ += "Aflossingsvorm=" + encodeURIComponent("" + aflossingsvorm) + "&";
        if (renteafspraak !== undefined && renteafspraak !== null)
            url_ += "Renteafspraak=" + encodeURIComponent("" + renteafspraak) + "&";
        if (rentevastAantalMaanden !== undefined && rentevastAantalMaanden !== null)
            url_ += "RentevastAantalMaanden=" + encodeURIComponent("" + rentevastAantalMaanden) + "&";
        if (rentebedenktijdInMaanden !== undefined && rentebedenktijdInMaanden !== null)
            url_ += "RentebedenktijdInMaanden=" + encodeURIComponent("" + rentebedenktijdInMaanden) + "&";
        if (percentageToShowList !== undefined && percentageToShowList !== null)
            url_ += "PercentageToShowList=" + encodeURIComponent("" + percentageToShowList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenteoverzichtObvRentevastperiode(_response);
        });
    }

    protected processRenteoverzichtObvRentevastperiode(response: Response): Promise<RenteoverzichtOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenteoverzichtOutput>(null as any);
    }

    /**
     * Geeft het renteoverzicht op basis van marktwaarde.
     * @param soortOnderpand (optional) Het soort onderpand waarvoor gezocht wordt. 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw
     * @param aflossingsvorm (optional) De aflossingsvorm die gezocht wordt. 0 = Geen, 1 = Annuïteit, 2 = Lineair, 3 = Levensverzekering, 4 = Spaar, 5 = Aflosvrij, 9 = Krediet, 10 = Belegging, 11 = Hybride, 12 = UnitLinked, 13 = Spaarrekening, 20 = AnnuïteitUitgesteld
     * @param marktwaardePercentage (optional) Het marktwaardepercentage waarnaar gezocht wordt.
     * @param nhg (optional) Geeft aan of Nhg meegenomen moet worden in de uitvoer.
     * @param jarenToShowList (optional) De jaren die opgenomen moeten worden. De jaren worden gescheiden door puntkomma's, bijvoorbeeld 1;5;10;30.
     * @return Success
     */
    renteoverzichtObvMarktwaarde(soortOnderpand: SoortOnderpand5 | null | undefined, aflossingsvorm: Aflossingsvorm3 | null | undefined, marktwaardePercentage: number | null | undefined, nhg: boolean | null | undefined, jarenToShowList: string | null | undefined): Promise<RenteoverzichtOutput> {
        let url_ = this.baseUrl + "/Renteoverzicht/ObvMarktwaardes?";
        if (soortOnderpand !== undefined && soortOnderpand !== null)
            url_ += "SoortOnderpand=" + encodeURIComponent("" + soortOnderpand) + "&";
        if (aflossingsvorm !== undefined && aflossingsvorm !== null)
            url_ += "Aflossingsvorm=" + encodeURIComponent("" + aflossingsvorm) + "&";
        if (marktwaardePercentage !== undefined && marktwaardePercentage !== null)
            url_ += "MarktwaardePercentage=" + encodeURIComponent("" + marktwaardePercentage) + "&";
        if (nhg !== undefined && nhg !== null)
            url_ += "Nhg=" + encodeURIComponent("" + nhg) + "&";
        if (jarenToShowList !== undefined && jarenToShowList !== null)
            url_ += "JarenToShowList=" + encodeURIComponent("" + jarenToShowList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenteoverzichtObvMarktwaarde(_response);
        });
    }

    protected processRenteoverzichtObvMarktwaarde(response: Response): Promise<RenteoverzichtOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenteoverzichtOutput>(null as any);
    }

    /**
     * Geeft het renteoverzicht per hypotheeklabel.
     * @param renteafspraak (optional) De renteafspraak die gezocht wordt. 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie
     * @param geldverstrekkerCode (optional) De code van de gevraagde geldverstrekker.
     * @param hypotheeklabelCode (optional) De code van het hypotheeklabel binnen de geldverstrekker.
     * @param hypotheekvormCode (optional) De code van de hypotheekvorm binnen het hypotheeklabel (RenteboxCode uit product API).
     * @param percentageToShowList (optional) De percentages die getoond moeten worden. De percentages worden gescheiden door puntkomma's, bijvoorbeeld 60;72,5;80;100.
     * @param soortOnderpand (optional) Geeft aan voor welke soort onderpand de gegevens opgehaald moeten worden. 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw
     * @return Success
     */
    renteoverzichtPerHypotheeklabel(renteafspraak: Renteafspraak5 | null | undefined, geldverstrekkerCode: string | null | undefined, hypotheeklabelCode: number | null | undefined, hypotheekvormCode: number | null | undefined, percentageToShowList: string | null | undefined, soortOnderpand: SoortOnderpand6 | null | undefined): Promise<RenteoverzichtOutput> {
        let url_ = this.baseUrl + "/Renteoverzicht/PerHypotheeklabel?";
        if (renteafspraak !== undefined && renteafspraak !== null)
            url_ += "Renteafspraak=" + encodeURIComponent("" + renteafspraak) + "&";
        if (geldverstrekkerCode !== undefined && geldverstrekkerCode !== null)
            url_ += "GeldverstrekkerCode=" + encodeURIComponent("" + geldverstrekkerCode) + "&";
        if (hypotheeklabelCode !== undefined && hypotheeklabelCode !== null)
            url_ += "HypotheeklabelCode=" + encodeURIComponent("" + hypotheeklabelCode) + "&";
        if (hypotheekvormCode !== undefined && hypotheekvormCode !== null)
            url_ += "HypotheekvormCode=" + encodeURIComponent("" + hypotheekvormCode) + "&";
        if (percentageToShowList !== undefined && percentageToShowList !== null)
            url_ += "PercentageToShowList=" + encodeURIComponent("" + percentageToShowList) + "&";
        if (soortOnderpand !== undefined && soortOnderpand !== null)
            url_ += "SoortOnderpand=" + encodeURIComponent("" + soortOnderpand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenteoverzichtPerHypotheeklabel(_response);
        });
    }

    protected processRenteoverzichtPerHypotheeklabel(response: Response): Promise<RenteoverzichtOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenteoverzichtOutput>(null as any);
    }

    /**
     * Geeft het renteoverzicht per hypotheeklabel incl. alle renteafspraken.
     * @param nhg (optional) Wel of geen NHG rentes in resultaat
     * @param geldverstrekkerCode (optional) De code van de gevraagde geldverstrekker.
     * @param hypotheeklabelCode (optional) De code van het hypotheeklabel binnen de geldverstrekker.
     * @param hypotheekvormCode (optional) De code van de hypotheekvorm binnen het hypotheeklabel (RenteboxCode uit product API).
     * @param percentageToShowList (optional) De percentages die getoond moeten worden. De percentages worden gescheiden door puntkomma's, bijvoorbeeld 60;72,5;80;100.
     * @param soortOnderpand (optional) Geeft aan voor welke soort onderpand de gegevens opgehaald moeten worden. 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw
     * @return Success
     */
    renteoverzichtPerHypotheeklabelAlleRenteAfspraken(nhg: boolean | null | undefined, geldverstrekkerCode: string | null | undefined, hypotheeklabelCode: number | null | undefined, hypotheekvormCode: number | null | undefined, percentageToShowList: string | null | undefined, soortOnderpand: SoortOnderpand7 | null | undefined): Promise<RenteoverzichtOutput> {
        let url_ = this.baseUrl + "/Renteoverzicht/PerHypotheeklabelMetAlleAfspraken?";
        if (nhg !== undefined && nhg !== null)
            url_ += "Nhg=" + encodeURIComponent("" + nhg) + "&";
        if (geldverstrekkerCode !== undefined && geldverstrekkerCode !== null)
            url_ += "GeldverstrekkerCode=" + encodeURIComponent("" + geldverstrekkerCode) + "&";
        if (hypotheeklabelCode !== undefined && hypotheeklabelCode !== null)
            url_ += "HypotheeklabelCode=" + encodeURIComponent("" + hypotheeklabelCode) + "&";
        if (hypotheekvormCode !== undefined && hypotheekvormCode !== null)
            url_ += "HypotheekvormCode=" + encodeURIComponent("" + hypotheekvormCode) + "&";
        if (percentageToShowList !== undefined && percentageToShowList !== null)
            url_ += "PercentageToShowList=" + encodeURIComponent("" + percentageToShowList) + "&";
        if (soortOnderpand !== undefined && soortOnderpand !== null)
            url_ += "SoortOnderpand=" + encodeURIComponent("" + soortOnderpand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenteoverzichtPerHypotheeklabelAlleRenteAfspraken(_response);
        });
    }

    protected processRenteoverzichtPerHypotheeklabelAlleRenteAfspraken(response: Response): Promise<RenteoverzichtOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenteoverzichtOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenteoverzichtOutput>(null as any);
    }

    /**
     * Haalt het rentepercentage op dat geldt voor de gegeven parameters.
     * @param geldverstrekkerCode Code van de geldverstrekker
     * @param hypotheeklabelCode Nummer van het hypotheeklabel van de geldverstrekker
     * @param hypotheekvormCode Nummer van de hypotheekvorm binnen het hypotheeklabel (RenteboxCode uit product API)
     * @param renteafspraak (optional) Renteafspraak die gezocht wordt. 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie
     * @param rentevastAantalMaanden (optional) Rentevastperiode die gezocht wordt (in aantal maanden).
     * @param rentebedenktijdInMaanden (optional) Bedenktijd die gezocht wordt (in aantal maanden).
     * @param bandbreedtePercentage (optional) Bandbreedtepercentage dat gezocht wordt.
     * @param soortOnderpand (optional) Soort onderpand dat gebruikt wordt. 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw
     * @param marktwaardePercentage (optional) Marktwaardepercentage dat gezocht wordt.
     * @param nhg (optional) Geeft aan of er sprake is van NHG.
     * @return Success
     */
    getRentepercentages(geldverstrekkerCode: string, hypotheeklabelCode: number, hypotheekvormCode: number, renteafspraak: Renteafspraak6 | null | undefined, rentevastAantalMaanden: number | null | undefined, rentebedenktijdInMaanden: number | null | undefined, bandbreedtePercentage: number | null | undefined, soortOnderpand: SoortOnderpand8 | null | undefined, marktwaardePercentage: number | null | undefined, nhg: boolean | null | undefined): Promise<RentepercentageOutput> {
        let url_ = this.baseUrl + "/Geldverstrekkers/{geldverstrekkerCode}/Hypotheeklabels/{hypotheeklabelCode}/Hypotheekvormen/{hypotheekvormCode}/Rentepercentages?";
        if (geldverstrekkerCode === undefined || geldverstrekkerCode === null)
            throw new Error("The parameter 'geldverstrekkerCode' must be defined.");
        url_ = url_.replace("{geldverstrekkerCode}", encodeURIComponent("" + geldverstrekkerCode));
        if (hypotheeklabelCode === undefined || hypotheeklabelCode === null)
            throw new Error("The parameter 'hypotheeklabelCode' must be defined.");
        url_ = url_.replace("{hypotheeklabelCode}", encodeURIComponent("" + hypotheeklabelCode));
        if (hypotheekvormCode === undefined || hypotheekvormCode === null)
            throw new Error("The parameter 'hypotheekvormCode' must be defined.");
        url_ = url_.replace("{hypotheekvormCode}", encodeURIComponent("" + hypotheekvormCode));
        if (renteafspraak !== undefined && renteafspraak !== null)
            url_ += "Renteafspraak=" + encodeURIComponent("" + renteafspraak) + "&";
        if (rentevastAantalMaanden !== undefined && rentevastAantalMaanden !== null)
            url_ += "RentevastAantalMaanden=" + encodeURIComponent("" + rentevastAantalMaanden) + "&";
        if (rentebedenktijdInMaanden !== undefined && rentebedenktijdInMaanden !== null)
            url_ += "RentebedenktijdInMaanden=" + encodeURIComponent("" + rentebedenktijdInMaanden) + "&";
        if (bandbreedtePercentage !== undefined && bandbreedtePercentage !== null)
            url_ += "BandbreedtePercentage=" + encodeURIComponent("" + bandbreedtePercentage) + "&";
        if (soortOnderpand !== undefined && soortOnderpand !== null)
            url_ += "SoortOnderpand=" + encodeURIComponent("" + soortOnderpand) + "&";
        if (marktwaardePercentage !== undefined && marktwaardePercentage !== null)
            url_ += "MarktwaardePercentage=" + encodeURIComponent("" + marktwaardePercentage) + "&";
        if (nhg !== undefined && nhg !== null)
            url_ += "Nhg=" + encodeURIComponent("" + nhg) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRentepercentages(_response);
        });
    }

    protected processGetRentepercentages(response: Response): Promise<RentepercentageOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentepercentageOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentepercentageOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentepercentageOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentepercentageOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentepercentageOutput>(null as any);
    }

    /**
     * Haalt voor meerdere hypotheeklabels het rentepercentage op dat geldt voor de gegeven parameters.
     * @param input (optional) De parameters waarmee de rente bepaald wordt
     * @return Success
     */
    getRentepercentageMeerdereHypotheeklabels(input: RentepercentageMeerdereHypotheeklabelsInput | null | undefined): Promise<RentepercentageMeerdereHypotheeklabelsOutput> {
        let url_ = this.baseUrl + "/Rentepercentages/MeerdereHypotheeklabels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRentepercentageMeerdereHypotheeklabels(_response);
        });
    }

    protected processGetRentepercentageMeerdereHypotheeklabels(response: Response): Promise<RentepercentageMeerdereHypotheeklabelsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentepercentageMeerdereHypotheeklabelsOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentepercentageMeerdereHypotheeklabelsOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentepercentageMeerdereHypotheeklabelsOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentepercentageMeerdereHypotheeklabelsOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentepercentageMeerdereHypotheeklabelsOutput>(null as any);
    }

    /**
     * Haalt de rentevarianten met onderliggende renteperiodes -en percentages op die gelden voor de gegeven parameters.
     * @param geldverstrekkerCode Code van de geldverstrekker
     * @param hypotheeklabelCode Nummer van het hypotheeklabel van de geldverstrekker
     * @param hypotheekvormCode Nummer van de hypotheekvorm binnen het hypotheeklabel (RenteboxCode uit product API)
     * @param soortOnderpand (optional) Soort onderpand dat gebruikt wordt 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw
     * @param marktwaardePercentage (optional) Marktwaardepercentage dat gezocht wordt
     * @param nhg (optional) Geeft aan of er sprake is van NHG
     * @return Success
     */
    rentevarianten_van_hypotheekvorm_met_renteperiodes_En_percentages_ophalen(geldverstrekkerCode: string, hypotheeklabelCode: number, hypotheekvormCode: number, soortOnderpand: SoortOnderpand9 | null | undefined, marktwaardePercentage: number | null | undefined, nhg: boolean | null | undefined): Promise<RentevariantMetRenteperiodesOutput> {
        let url_ = this.baseUrl + "/Geldverstrekkers/{geldverstrekkerCode}/Hypotheeklabels/{hypotheeklabelCode}/Hypotheekvormen/{hypotheekvormCode}/Rentevarianten?";
        if (geldverstrekkerCode === undefined || geldverstrekkerCode === null)
            throw new Error("The parameter 'geldverstrekkerCode' must be defined.");
        url_ = url_.replace("{geldverstrekkerCode}", encodeURIComponent("" + geldverstrekkerCode));
        if (hypotheeklabelCode === undefined || hypotheeklabelCode === null)
            throw new Error("The parameter 'hypotheeklabelCode' must be defined.");
        url_ = url_.replace("{hypotheeklabelCode}", encodeURIComponent("" + hypotheeklabelCode));
        if (hypotheekvormCode === undefined || hypotheekvormCode === null)
            throw new Error("The parameter 'hypotheekvormCode' must be defined.");
        url_ = url_.replace("{hypotheekvormCode}", encodeURIComponent("" + hypotheekvormCode));
        if (soortOnderpand !== undefined && soortOnderpand !== null)
            url_ += "soortOnderpand=" + encodeURIComponent("" + soortOnderpand) + "&";
        if (marktwaardePercentage !== undefined && marktwaardePercentage !== null)
            url_ += "marktwaardePercentage=" + encodeURIComponent("" + marktwaardePercentage) + "&";
        if (nhg !== undefined && nhg !== null)
            url_ += "nhg=" + encodeURIComponent("" + nhg) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRentevarianten_van_hypotheekvorm_met_renteperiodes_En_percentages_ophalen(_response);
        });
    }

    protected processRentevarianten_van_hypotheekvorm_met_renteperiodes_En_percentages_ophalen(response: Response): Promise<RentevariantMetRenteperiodesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentevariantMetRenteperiodesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentevariantMetRenteperiodesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentevariantMetRenteperiodesOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentevariantMetRenteperiodesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentevariantMetRenteperiodesOutput>(null as any);
    }

    /**
     * Haalt de HDN waarde van de CodeRenteMij op uit de rentedatabase, op basis van de opgegeven geldverstrekkerscode en rentesoortcode
     * @param geldverstrekkerCode Code van de geldverstrekker
     * @param rentesoortCode Code van de rentesoort
     * @return Success
     */
    codeRenteMij_ophalen(geldverstrekkerCode: string, rentesoortCode: number): Promise<CodeRenteMijOutput> {
        let url_ = this.baseUrl + "/Geldverstrekkers/{geldverstrekkerCode}/Rentesoorten/{rentesoortCode}/CodeRenteMij";
        if (geldverstrekkerCode === undefined || geldverstrekkerCode === null)
            throw new Error("The parameter 'geldverstrekkerCode' must be defined.");
        url_ = url_.replace("{geldverstrekkerCode}", encodeURIComponent("" + geldverstrekkerCode));
        if (rentesoortCode === undefined || rentesoortCode === null)
            throw new Error("The parameter 'rentesoortCode' must be defined.");
        url_ = url_.replace("{rentesoortCode}", encodeURIComponent("" + rentesoortCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCodeRenteMij_ophalen(_response);
        });
    }

    protected processCodeRenteMij_ophalen(response: Response): Promise<CodeRenteMijOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeRenteMijOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeRenteMijOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeRenteMijOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeRenteMijOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeRenteMijOutput>(null as any);
    }

    /**
     * Geeft versie informatie van de applicatie.
     * @return De gevraagde versieinfo kon worden opgehaald en is beschikbaar in de uitvoer.
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Er is iets foutgegaan tijdens het ophalen van de versieinfo. Kijken in de Messages van de uitvoer voor het probleem.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * Geeft de foutcodes die in deze Web API kunnen ontstaan.
     * @return Success
     */
    getFoutcodes(): Promise<void> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

/** Het resultaat van het ophalen van de geldverstrekkers. */
export interface GeldverstrekkersOutput {
    /** Lijst met geldverstrekkers */
    geldverstrekkers: { [key: string]: Geldverstrekker; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van de geldverstrekker. */
export interface Geldverstrekker {
    /** Code van de geldverstrekker. */
    code: string | null;
    /** Naam van de geldverstrekker. */
    naam: string | null;
    /** Versienummer van de laatste wijziging. */
    versienummer: string | null;
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

/** De uitvoer van rentevastperiodes. */
export interface RentevastperiodesOutput {
    /** Voor elke gevonden rentevastperiode wordt een item in de lijst opgenomen. */
    rentevastperiodes: Rentevastperiode[] | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De uitvoer van een rentevastperiode. */
export interface Rentevastperiode {
    /** De code van de rentevastperidoe. */
    code: number | null;
    /** De omschrijving van de rentevastperiode. */
    omschrijving: string | null;
    /** De renteafspraak van de gevonden rentevastperiode. 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie */
    renteAfspraak: RentevastperiodeRenteAfspraak | null;
    /** Het aantal maanden in de rentevastperiode. */
    rentevastAantalMaanden: number | null;
    /** Het rentepercentage. */
    percentage: number | null;
    /** De bovenmarge (indien van toepassing). */
    ondermarge: number | null;
    /** De ondermarge (indien van toepassing). */
    bovenmarge: number | null;
}

/** Informatie over de geldverstrekkers met toetsrente. */
export interface HasToetsrenteOutput {
    /** Een lijst met codes van geldverstrekkers die toetsrente hebben. */
    geldverstrekkerCodes: string[] | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De uitvoer van hypotheeklabels. */
export interface HypotheeklabelsOutput {
    /** Lijst met hypotheeklabels */
    hypotheeklabels: { [key: string]: Hypotheeklabel; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een hypotheeklabel. */
export interface Hypotheeklabel {
    /** Code van het hypotheeklabel binnen een geldverstrekker. */
    code: number | null;
    /** Code van de geldverstrekker. */
    geldverstrekkerCode: string | null;
    /** Omschrijving van het hypotheeklabel. */
    omschrijving: string | null;
    /** Ingangsdatum van het hypotheeklabel. */
    ingangsdatum: string | null;
}

/** De uitvoer van hypotheekvormen. */
export interface HypotheekvormenOutput {
    /** Lijst met hypotheekvormen */
    hypotheekvormen: { [key: string]: Hypotheekvorm; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een hypotheekvorm. */
export interface Hypotheekvorm {
    /** Code van de hypotheekvorm. Koppeling met ../hypotheek/box_cd uit Rentebox-xml */
    renteboxCode: number | null;
    /** Omschrijving van de hypotheekvorm. */
    omschrijving: string | null;
    /** Aflossingsvorm van de hypotheekvorm. 0 = Geen, 1 = Annuïteit, 2 = Lineair, 3 = Levensverzekering, 4 = Spaar, 5 = Aflosvrij, 9 = Krediet, 10 = Belegging, 11 = Hybride, 12 = UnitLinked, 13 = Spaarrekening, 20 = AnnuïteitUitgesteld */
    aflossingsvorm: HypotheekvormAflossingsvorm | null;
}

/** Het resultaat van een opvraging van het maximale marktwaardepercentage. */
export interface MaxMarktwaardePercentageOutput {
    /** Het gevonden maximale marktwaardepercentage. */
    maxMarktwaardePercentage: number | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Het resultaat van een opvraging van marktwaardes. */
export interface MarktwaardesOutput {
    /** De gevonden marktwaardes. */
    marktwaardes: Marktwaarde[] | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De gegevens over een marktwaarde. */
export interface Marktwaarde {
    /** Geeft aan of de marktwaarde bedoeld is in combinatie met NHG. */
    readonly nhg: boolean | null;
    /** Geeft de ondergrens van de marktwaarde. */
    readonly marktwaardePercentageVanaf: number | null;
    /** Geeft de bovengrens van de marktwaarde. */
    readonly marktwaardePercentageTotEnMet: number | null;
    /** De opslag ten opzichte van het rentepercentage van de laagste marktwaarde. */
    readonly renteopslagPercentage: number | null;
    /** Het rentepercentage dat hoort bij de hoort bij de marktwaarderange. */
    readonly rentepercentage: number | null;
}

/** Input voor het opvragen van marktwaardes voor meerdere leningdelen. */
export interface HypotheeklabelMarktwaardeInput {
    /** Soort onderpand dat gebruikt wordt. 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw */
    soortOnderpand: HypotheeklabelMarktwaardeInputSoortOnderpand | null;
    /** Marktwaardepercentage dat gezocht wordt. */
    marktwaardePercentage: number | null;
    /** Geeft aan of er sprake is van NHG. */
    nhg: boolean | null;
    /** Leningdelen waarvoor de marktwaardes bepaald moeten worden. */
    leningdelen: HypotheeklabelMarktwaardeLeningdeel[] | null;
}

/** Bevat gegevens van een leningdeel. */
export interface HypotheeklabelMarktwaardeLeningdeel {
    /** Aflossingsvorm van de hypotheekvorm. 0 = Geen, 1 = Annuïteit, 2 = Lineair, 3 = Levensverzekering, 4 = Spaar, 5 = Aflosvrij, 9 = Krediet, 10 = Belegging, 11 = Hybride, 12 = UnitLinked, 13 = Spaarrekening, 20 = AnnuïteitUitgesteld */
    aflossingsvorm: HypotheeklabelMarktwaardeLeningdeelAflossingsvorm | null;
    /** Renteafspraak die gezocht wordt. 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie */
    renteafspraak: HypotheeklabelMarktwaardeLeningdeelRenteafspraak | null;
    /** Rentevastperiode die gezocht wordt (in aantal maanden). */
    rentevastAantalMaanden: number | null;
    /** Bedenktijd die gezocht wordt (in aantal maanden). */
    rentebedenktijdInMaanden: number | null;
}

/** Het resultaat van een opvraging van marktwaardes voor meerdere leningdelen voor meerdere hypotheeklabels. */
export interface HypotheeklabelMarktwaardesOutput {
    /** De opgevraagde hypotheeklabels met onderliggende hypotheekvormen. */
    hypotheeklabelMarktwaardes: HypotheeklabelMarktwaarde[] | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het hypotheeklabel met onderliggnde hypotheekvormen. */
export interface HypotheeklabelMarktwaarde {
    /** Het hypotheeklabel. */
    hypotheeklabel: Hypotheeklabel | null;
    /** De hypotheekvormen die overeenkomen met de gevraagde aflossingsvormen en bijbehorende marktwaardes. */
    hypotheekvormMarktwaardes: HypotheekvormMarktwaarde[] | null;
}

/** Bevat de hypotheekvorm die overeenkomt met de gevraagde aflossingsvormen en bijbehorende marktwaardes. */
export interface HypotheekvormMarktwaarde {
    /** De hypotheekvorm. */
    hypotheekvorm: Hypotheekvorm | null;
    /** De gevonden marktwaardes voor de hypotheekvorm. */
    marktwaardes: Marktwaarde[] | null;
}

/** Resultaat van een opgevraagd renteoverzicht. */
export interface RenteoverzichtOutput {
    /** Het opgevraagde renteoverzicht. */
    renteoverzicht: any | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De uitvoer voor het opvragen van een rentepercentage. */
export interface RentepercentageOutput {
    /** Het gevonden rentepercentage. */
    rentepercentage: Rentepercentage | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Uitvoer van de opvraging van een rentepercentage. */
export interface Rentepercentage {
    /** Het gevonden rentepercentage. */
    percentage: number | null;
    /** De bovenmarge indien van toepassing. */
    bovenmarge: number | null;
    /** De ondermarge indien van toepassing. */
    ondermarge: number | null;
}

/** Parameters voor de opvraging van een rentepercentage voor meerdere hypotheeklabels. */
export interface RentepercentageMeerdereHypotheeklabelsInput {
    /** Lijst met hypotheeklabels waarvoor de rente bepaald moet worden. */
    hypotheeklabels: RentepercentageHypotheeklabel[] | null;
    /** Renteafspraak die gezocht wordt. 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie */
    renteafspraak: RentepercentageMeerdereHypotheeklabelsInputRenteafspraak | null;
    /** Rentevastperiode die gezocht wordt (in aantal maanden). */
    rentevastAantalMaanden: number | null;
    /** Bedenktijd die gezocht wordt (in aantal maanden). */
    rentebedenktijdInMaanden: number | null;
    /** Bandbreedtepercentage dat gezocht wordt. */
    bandbreedtePercentage: number | null;
    /** Soort onderpand dat gebruikt wordt. 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw */
    soortOnderpand: RentepercentageMeerdereHypotheeklabelsInputSoortOnderpand | null;
    /** Marktwaardepercentage dat gezocht wordt. */
    marktwaardePercentage: number | null;
    /** Geeft aan of er sprake is van NHG. */
    nhg: boolean | null;
}

/** Bevat gegevens van een hypotheeklabel. */
export interface RentepercentageHypotheeklabel {
    /** Code van het hypotheeklabel binnen een geldverstrekker. */
    hypotheeklabelCode: number | null;
    /** Code van de geldverstrekker. */
    geldverstrekkerCode: string | null;
}

/** De uitvoer voor het opvragen van een rentepercentage voor meerdere hypotheeklabels. */
export interface RentepercentageMeerdereHypotheeklabelsOutput {
    /** Lijst met gevonden rentepercentages met bijbehorende hypotheeklabels. */
    hypotheeklabelRentepercentages: HypotheeklabelRentepercentage[] | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het gevonden rentepercentage voor een bepaald hypotheeklabel. */
export interface HypotheeklabelRentepercentage {
    /** Het gevonden rentepercentage. */
    rentepercentage: Rentepercentage | null;
    /** Het hypotheeklabel dat hoort bij het gevonden rentepercentage. */
    hypotheeklabel: RentepercentageHypotheeklabel | null;
}

/** Resultaat van een opgevraagde rentevarianten met onderliggende renteperiodes. */
export interface RentevariantMetRenteperiodesOutput {
    /** Lijst met rentevarianten met onderliggende renteperiodes. */
    rentevarianten: RentevariantMetRenteperiodes[] | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Uitvoer van de opvraging van een rentevariant met onderliggende renteperiodes. */
export interface RentevariantMetRenteperiodes {
    /** Code van de rentesoort zoals deze door Rentebox wordt gehanteerd */
    code: number | null;
    /** Renteafspraak 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie */
    renteafspraak: RentevariantMetRenteperiodesRenteafspraak | null;
    /** Omschrijving */
    omschrijving: string | null;
    /** Een waarschuwing geven als er met de gevraagde marktwaarde niet direct rentens terug gegeven kunnen worden */
    marktwaardeWaarschuwingTonen: boolean | null;
    /** De onderliggende rentepercentages */
    renteperiodes: RenteperiodeMetRentepercentage[] | null;
}

/** Uitvoer van de opvraging van een renteperiode met bijbehorend rentepercentage. */
export interface RenteperiodeMetRentepercentage {
    /** Rentevastperiode die gezocht wordt (in aantal maanden). */
    rentevastAantalMaanden: number | null;
    /** Bedenktijd die gezocht wordt (in aantal maanden). */
    rentebedenktijdInMaanden: number | null;
    /** Het bijbehorende rentepercentage */
    rentepercentage: Rentepercentage | null;
}

/** Het resultaat van een opvraging van de CodeRenteMij. */
export interface CodeRenteMijOutput {
    /** Het gevonden maximale marktwaardepercentage. */
    codeRenteMij: string | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

/** De aflossingsvorm die gevraagd wordt 0 = Geen, 1 = Annuïteit, 2 = Lineair, 3 = Levensverzekering, 4 = Spaar, 5 = Aflosvrij, 9 = Krediet, 10 = Belegging, 11 = Hybride, 12 = UnitLinked, 13 = Spaarrekening, 20 = AnnuïteitUitgesteld */
export enum Aflossingsvorm {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _20 = 20,
}

/** De renteafspraak die gevraagd wordt 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie */
export enum Renteafspraak {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _9 = 9,
}

/** Het soort onderpand dat gevraagd wordt 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw */
export enum SoortOnderpand {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** Renteafspraak die gezocht wordt 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie */
export enum Renteafspraak2 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _9 = 9,
}

/** Soort onderpand dat gebruikt wordt 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw */
export enum SoortOnderpand2 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** Renteafspraak die gezocht wordt 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie */
export enum Renteafspraak3 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _9 = 9,
}

/** Soort onderpand dat gebruikt wordt 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw */
export enum SoortOnderpand3 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** Het soort onderpand waarvoor gezocht wordt 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw */
export enum SoortOnderpand4 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** De aflossingsvorm die gezocht wordt 0 = Geen, 1 = Annuïteit, 2 = Lineair, 3 = Levensverzekering, 4 = Spaar, 5 = Aflosvrij, 9 = Krediet, 10 = Belegging, 11 = Hybride, 12 = UnitLinked, 13 = Spaarrekening, 20 = AnnuïteitUitgesteld */
export enum Aflossingsvorm2 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _20 = 20,
}

/** De renteafspraak die gezocht wordt 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie */
export enum Renteafspraak4 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _9 = 9,
}

/** Het soort onderpand waarvoor gezocht wordt. 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw */
export enum SoortOnderpand5 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** De aflossingsvorm die gezocht wordt. 0 = Geen, 1 = Annuïteit, 2 = Lineair, 3 = Levensverzekering, 4 = Spaar, 5 = Aflosvrij, 9 = Krediet, 10 = Belegging, 11 = Hybride, 12 = UnitLinked, 13 = Spaarrekening, 20 = AnnuïteitUitgesteld */
export enum Aflossingsvorm3 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _20 = 20,
}

/** De renteafspraak die gezocht wordt. 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie */
export enum Renteafspraak5 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _9 = 9,
}

/** Geeft aan voor welke soort onderpand de gegevens opgehaald moeten worden. 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw */
export enum SoortOnderpand6 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** Geeft aan voor welke soort onderpand de gegevens opgehaald moeten worden. 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw */
export enum SoortOnderpand7 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** Renteafspraak die gezocht wordt. 0 = Geen, 1 = Rentevast, 2 = Rentedempend, 3 = ContinuVariabel, 4 = Correctie, 5 = PlafondClick, 6 = Samengesteld, 9 = Orientatie */
export enum Renteafspraak6 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _9 = 9,
}

/** Soort onderpand dat gebruikt wordt. 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw */
export enum SoortOnderpand8 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** Soort onderpand dat gebruikt wordt 0 = Geen, 1 = BestaandeBouw, 2 = BestaandeVerbouw, 3 = Nieuwbouw */
export enum SoortOnderpand9 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum RentevastperiodeRenteAfspraak {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _9 = 9,
}

export enum HypotheekvormAflossingsvorm {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _20 = 20,
}

export enum HypotheeklabelMarktwaardeInputSoortOnderpand {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum HypotheeklabelMarktwaardeLeningdeelAflossingsvorm {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _20 = 20,
}

export enum HypotheeklabelMarktwaardeLeningdeelRenteafspraak {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _9 = 9,
}

export enum RentepercentageMeerdereHypotheeklabelsInputRenteafspraak {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _9 = 9,
}

export enum RentepercentageMeerdereHypotheeklabelsInputSoortOnderpand {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum RentevariantMetRenteperiodesRenteafspraak {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _9 = 9,
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}